var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.875C18 15.7038 17.6708 16.4987 17.0847 17.0847C16.4987 17.6708 15.7038 18 14.875 18H3.125C2.2962 18 1.50134 17.6708 0.915291 17.0847C0.32924 16.4987 0 15.7038 0 14.875V5L9 4.5L18 5V14.875Z",
    fill: "url(#paint0_linear_707_53)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.875C18 15.7038 17.6708 16.4987 17.0847 17.0847C16.4987 17.6708 15.7038 18 14.875 18H3.125C2.2962 18 1.50134 17.6708 0.915291 17.0847C0.32924 16.4987 0 15.7038 0 14.875V5L9 4.5L18 5V14.875Z",
    fill: "url(#paint1_linear_707_53)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_707_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 10C5.08152 10 5.39946 9.8683 5.63388 9.63388C5.8683 9.39946 6 9.08152 6 8.75C6 8.41848 5.8683 8.10054 5.63388 7.86612C5.39946 7.6317 5.08152 7.5 4.75 7.5C4.41848 7.5 4.10054 7.6317 3.86612 7.86612C3.6317 8.10054 3.5 8.41848 3.5 8.75C3.5 9.08152 3.6317 9.39946 3.86612 9.63388C4.10054 9.8683 4.41848 10 4.75 10ZM10.25 8.75C10.25 9.08152 10.1183 9.39946 9.88388 9.63388C9.64946 9.8683 9.33152 10 9 10C8.66848 10 8.35054 9.8683 8.11612 9.63388C7.8817 9.39946 7.75 9.08152 7.75 8.75C7.75 8.41848 7.8817 8.10054 8.11612 7.86612C8.35054 7.6317 8.66848 7.5 9 7.5C9.33152 7.5 9.64946 7.6317 9.88388 7.86612C10.1183 8.10054 10.25 8.41848 10.25 8.75ZM13.25 10C13.5815 10 13.8995 9.8683 14.1339 9.63388C14.3683 9.39946 14.5 9.08152 14.5 8.75C14.5 8.41848 14.3683 8.10054 14.1339 7.86612C13.8995 7.6317 13.5815 7.5 13.25 7.5C12.9185 7.5 12.6005 7.6317 12.3661 7.86612C12.1317 8.10054 12 8.41848 12 8.75C12 9.08152 12.1317 9.39946 12.3661 9.63388C12.6005 9.8683 12.9185 10 13.25 10ZM6 12.75C6 13.0815 5.8683 13.3995 5.63388 13.6339C5.39946 13.8683 5.08152 14 4.75 14C4.41848 14 4.10054 13.8683 3.86612 13.6339C3.6317 13.3995 3.5 13.0815 3.5 12.75C3.5 12.4185 3.6317 12.1005 3.86612 11.8661C4.10054 11.6317 4.41848 11.5 4.75 11.5C5.08152 11.5 5.39946 11.6317 5.63388 11.8661C5.8683 12.1005 6 12.4185 6 12.75ZM9 14C9.33152 14 9.64946 13.8683 9.88388 13.6339C10.1183 13.3995 10.25 13.0815 10.25 12.75C10.25 12.4185 10.1183 12.1005 9.88388 11.8661C9.64946 11.6317 9.33152 11.5 9 11.5C8.66848 11.5 8.35054 11.6317 8.11612 11.8661C7.8817 12.1005 7.75 12.4185 7.75 12.75C7.75 13.0815 7.8817 13.3995 8.11612 13.6339C8.35054 13.8683 8.66848 14 9 14Z",
    fill: "url(#paint2_linear_707_53)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 0C2.2962 0 1.50134 0.32924 0.915291 0.915291C0.32924 1.50134 0 2.2962 0 3.125V5H18V3.125C18 2.2962 17.6708 1.50134 17.0847 0.915291C16.4987 0.32924 15.7038 0 14.875 0H3.125Z",
    fill: "url(#paint3_linear_707_53)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_707_53",
    x: 2.833,
    y: 7.1665,
    width: 12.334,
    height: 7.834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.3335
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3335
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1242 0 0 0 0 0.323337 0 0 0 0 0.7958 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_707_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_707_53",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_707_53",
    x1: 12.25,
    y1: 19.658,
    x2: 7.4865,
    y2: 5.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3E0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_707_53",
    x1: 10.9285,
    y1: 10.023,
    x2: 13.2815,
    y2: 21.1145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCF8FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6CE8",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_707_53",
    x1: 8,
    y1: 6.75,
    x2: 10.0215,
    y2: 19.7465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0067BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_707_53",
    x1: 0,
    y1: 0,
    x2: 15.3715,
    y2: -4.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0094F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2764E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/IconCalendar.2d24be6fffa549bfd94546c087ecdf1d.svg";
export { ForwardRef as ReactComponent };